
import { defineComponent } from "vue";
import "@/assets/scss/component/add-patient.scss";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "add-panient",
});
